import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dylan from "../assets/Dylan.jpg";
import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Footer from "../components/Footer";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Navbar from "../components/Navbar";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState, useEffect } from "react";
import Fade from "@mui/material/Fade";
import SubdirectoryArrowRightSharpIcon from "@mui/icons-material/SubdirectoryArrowRightSharp";
import moto1 from "../assets/moto1.png";
import moto2 from "../assets/moto2.png";
import disabled_dylan from "../assets/disabled_dylan.png";

const loadingTexts = ["About Me"];

function Me() {
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      href="Resume_Tianxiang_Ren.pdf"
      target="_blank"
    >
      <span className="intro">
        <SubdirectoryArrowRightSharpIcon /> Get My Resume
      </span>
    </Link>,
    <div style={{ paddingLeft: "150px" }}>
      <a href="https://www.linkedin.com/in/rentxiang/" className="p-3">
        <LinkedInIcon color="" fontSize="large" />
      </a>
      <a href="https://github.com/rentxiang" className="p-3">
        <GitHubIcon color="" fontSize="large" />
      </a>

      <a href="mailto:rentxiang@gmail.com" className="p-3">
        <EmailIcon color="" fontSize="large" />
      </a>
    </div>,
  ];

  const [textProgress, setTextProgress] = useState(0);

  useEffect(() => {
    const totalTextLength = loadingTexts.reduce(
      (total, text) => total + text.length,
      0
    );
    const increment = 1;

    const timer = setInterval(() => {
      setTextProgress((prevProgress) => prevProgress + increment);
    }, 100);

    if (textProgress >= totalTextLength) {
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  }, [textProgress]);
  return (
    <section>
      <Container>
        <Navbar />
        <Row
          className="d-flex p-7 align-items-center justify-content-center"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <Col lg={7} md={8} className="p-4">
            {loadingTexts.map((text, index) => (
              <h1 className="name py-4" style={{ textAlign: "left" }}>
                <ArrowForwardIosIcon xs={{ fontSize: "large", color: "red" }} />{" "}
                {text.substring(0, textProgress)}
              </h1>
            ))}
            <br />
            <Fade in={true} timeout={3000}>
              <div>
                <p className="intro" style={{ textAlign: "left" }}>
                  Software engineer based in San Francisco. M.S. in Information Systems from Northeastern University.
                </p>
                <p className="intro" style={{ textAlign: "left" }}>
                  I build full-stack web and mobile products — currently at Reputation.com, focused on React, TypeScript, and Java.
                </p>
                <p className="intro" style={{ textAlign: "left" }}>
                  Feel free to reach out via LinkedIn or at rentxiang@gmail.com.
                </p>
              </div>
            </Fade>

            <Fade in={true} timeout={7000}>
              <div>
                <br />

                <div style={{ textAlign: "left", marginTop: 100 }}>
                  <Breadcrumbs
                    separator=" "
                    aria-label="breadcrumb"
                    className="d-flex p-7 align-items-left justify-content-left "
                  >
                    {breadcrumbs}
                  </Breadcrumbs>
                </div>
              </div>
            </Fade>
          </Col>
          <Col lg={3} md={2} className="p-4">
            <img src={Dylan} style={{ width: "100%" }} alt="logo" />
          </Col>
        </Row>
        <Fade in={true} timeout={8000}>
          <div>
            <Row
              className="d-flex align-items-center justify-content-center"
              style={{
                // display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh",
              }}
            >
              <hr />

              <Col lg={10} md={10} className="p-4">
                <h1 className="name py-5" style={{ textAlign: "left" }}>
                  Life
                </h1>
                <p className="intro" style={{ textAlign: "left" }}>
                  I was a motorcyclist, I enjoyed traveling and gaining diverse
                  perspectives from different people.
                </p>
              </Col>
            </Row>
            <Row
              className="d-flex align-items-center justify-content-center"
              style={{
                // display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh",
              }}
            >
              <Col lg={5} md={5} className="p-4">
                <img src={moto1} style={{ width: "70%" }} alt="logo" />
              </Col>
              <Col lg={5} md={5} className="p-4">
                <img src={moto2} style={{ width: "100%" }} alt="logo" />
              </Col>
            </Row>
            <Row
              className="d-flex align-items-center justify-content-center pt-5"
              style={{
                // display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh",
              }}
            >
              <Col lg={5} md={5} className="p-4">
                <img src={disabled_dylan} style={{ width: "73%" }} alt="logo" />
              </Col>

              <Col lg={5} md={5} className="p-4">
                <p className="intro" style={{ textAlign: "left" }}>
                  In 2024 August, I had an accident and crashed my motorycle, no
                  more motorycles! 😭
                </p>
              </Col>
            </Row>
            {/* <Row
              className="d-flex align-items-center justify-content-center"
              style={{
                // display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh",
              }}
            >
              <Col lg={10} md={10} className="p-4">
                <p className="intro" style={{ textAlign: "left" }}>
                  I have 2 little families - I have a delightful Pug dog 🐶 and
                  an adorable mix of a Calico and Siamese cat 🐱, and I
                  absolutely adore them.
                </p>
              </Col>
            </Row>

            <Row
              className="d-flex align-items-center justify-content-center"
              style={{
                // display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh",
              }}
            >
              <Col lg={5} md={5} className="p-4">
                <img src={huihui} style={{ width: "60%" }} alt="logo" />
              </Col>
              <Col lg={5} md={5} className="p-4">
                <p className="intro" style={{ textAlign: "left" }}>
                  "Hui hui" means "grey grey" in Mandarin, his name is derived
                  from Xiao Huihui in the Chinese animated series "Pleasant Goat
                  and Big Big Wolf."
                </p>
                <p className="intro" style={{ textAlign: "left" }}>
                  Huihui accompanied me throughout my school years. It's been 2
                  years I haven't been back home and I miss him.
                </p>
              </Col>
            </Row>
            <Row
              className="d-flex align-items-center justify-content-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh",
              }}
            >
              <Col lg={5} md={5} className="p-4">
                <p className="intro" style={{ textAlign: "left" }}>
                  The bubble, paopao is my lovely princess and she's beautiful.
                  I adopted paopao from one of my friend since June.
                </p>
                <p className="intro" style={{ textAlign: "left" }}>
                  She is very shy and timid, yet incredibly affectionate and
                  clingy. She is becoming my sweetheart!
                </p>
              </Col>
              <Col lg={5} md={5} className="p-4">
                <img src={paopao} style={{ width: 300 }} alt="logo" />
              </Col>

              <hr />
            </Row> */}
          </div>
        </Fade>
        <Footer />
      </Container>
    </section>
  );
}

export default Me;
